import { CheckCircleFillSVG } from 'common/assets';
import stylesColors from 'common/styles/styles.colors';
import PurchasePillStatus from 'legacy-modules/order/component/status';
import RefundPillStatus from 'legacy-modules/refund/components/refund-pill-status';
import ReleasePillStatus from 'legacy-modules/refund/components/release-pill-status';
import { ItemCenter, Title, TitleContainer } from 'legacy-modules/styles';
import TourPillStatus from 'legacy-modules/tour/tour-list/components/status';
import TransactionPillStatus from 'legacy-modules/transactions/component/status';

import SalePillStatus from '../sales/component/status';
import DocumentPillStatus from '../sales/travel-document/components/status';

interface Props {
  title: string;
  status: string;
  isCompleted?: boolean;
  type?:
    | 'sale-default'
    | 'sale-document'
    | 'purchase'
    | 'refund'
    | 'release'
    | 'transaction'
    | 'tour';
}

export default function TitleStatus(props: Props) {
  const { title, status, isCompleted = false, type } = props;

  const renderStatus = () => {
    switch (type) {
      case 'sale-document':
        return (
          <DocumentPillStatus style={{ minHeight: '28px' }} value={status} />
        );
      case 'sale-default':
        return <SalePillStatus style={{ minHeight: '28px' }} value={status} />;
      case 'purchase':
        return (
          <PurchasePillStatus style={{ minHeight: '28px' }} value={status} />
        );
      case 'refund':
        return (
          <RefundPillStatus style={{ minHeight: '28px' }} value={status} />
        );
      case 'release':
        return (
          <ReleasePillStatus style={{ minHeight: '28px' }} value={status} />
        );
      case 'transaction':
        return (
          <TransactionPillStatus style={{ minHeight: '28px' }} value={status} />
        );
      case 'tour':
        return <TourPillStatus style={{ minHeight: '28px' }} value={status} />;
      default:
        return <></>;
    }
  };

  return (
    <TitleContainer>
      <Title variant="HeadingXSmall">{title}</Title>

      <div style={{ display: 'flex', gap: '16px' }}>
        {renderStatus()}
        {!!isCompleted && (
          <ItemCenter>
            <CheckCircleFillSVG color={stylesColors.primaryDefault} />
          </ItemCenter>
        )}
      </div>
    </TitleContainer>
  );
}
